export default __webpack_public_path__ + "static/media/ipad2-inverted.0a1a8bdc.png";